import React from "react";

const PdfUnavailable = () => (
    <div className="PdfUnavailable" style={{ margin: 20 }}>
        <h2>PDF non disponible</h2>
        <p>Votre demande n'a pas pu être traitée, le PDF est indisponible</p>
    </div>
);

export default PdfUnavailable;